import { use } from 'react'
import Input from '@talkdesk/cobalt-react-input'
import Button from '@talkdesk/cobalt-react-button'
import Label from '@talkdesk/cobalt-react-label'
import Box from '@talkdesk/cobalt-react-box'
import MFAHeader from '../../components/MFAHeader'
import ErrorMessage from '../../components/ErrorMessage'
import useMFA from '../../hooks/useMFA'
import { LoginContext } from '../../contexts/Login'
import { useTranslation } from 'react-i18next'
import { TOTP as TOTP_TYPE } from '../../constants/mfa.types'

export const TOTP = ({ csrf, ctx }) => {
  const { t } = useTranslation()
  const {
    code,
    showError,
    verifyButtonState,
    disabledForm,
    errorMessage,
    isVerifyButtonDisabled,
    handleCodeChange,
    doLogin,
  } = useMFA({
    invalidCodeErrorMessage: () => t('totp.invalidError'),
    genericErrorMessage: () => t('totp.genericError'),
  })

  const handleSubmit = () => {
    const mfa = {
      type: TOTP_TYPE,
      payload: {
        totp: code,
      },
    }
    doLogin(csrf, ctx.credentials, mfa)
  }

  return (
    <>
      <MFAHeader
        icon='phonelink_lock'
        iconColor='green600'
        title={t('totp.title')}
        subtitle={t('totp.description')}
      />
      <form
        onSubmit={(e) => {
          e.preventDefault()
          handleSubmit()
        }}
      >
        {showError ? <ErrorMessage message={errorMessage} /> : null}
        <div>
          <Label htmlFor='totp-code'>{t('totp.verificationCode')}</Label>
          <Box paddingTop={2} />
          <Input
            id='totp-code'
            autoFocus
            value={code}
            onChange={handleCodeChange}
            placeholder={t('totp.verificationCode')}
            type='text'
            inputMode='numeric'
            pattern='[0-9]*'
            disabled={disabledForm}
          />
        </div>
        <Box paddingTop={4} />
        <Button
          htmlType='submit'
          disabled={isVerifyButtonDisabled()}
          state={verifyButtonState}
          type='primary'
          shape='full-width'
        >
          {t('mfa.verify')}
        </Button>
      </form>
    </>
  )
}

const TOTPWithContext = (props) => {
  const ctx = use(LoginContext)
  return <TOTP ctx={ctx} {...props} />
}
TOTPWithContext.displayName = 'TOTP'

export default TOTPWithContext
